import { movies } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";

export default function HotRecommendSection() {
  const hotMovies = movies.filter((m) => m.isHot);

  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门推荐</h2>
            <p className="text-sm text-foreground-500">大家都在看的精彩内容，不容错过</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: "oklch(var(--accent-500))" }}></span>
            <span className="text-xs text-foreground-500">实时更新</span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              category={movie.category}
              year={movie.year}
              rating={movie.rating}
              imageUrl={movie.imageUrl}
            />
          ))}
        </div>
      </div>
    </section>
  );
}